import styled from "styled-components";

// import { Default } from "Types";

import AtomTitle from "Components/Atoms/Title";
import OrganismForm from "Components/Organisms/Form5";
import OrganismSteps from "Components/Organisms/Steps";
import AtomButton from "Components/Atoms/Button";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;

const Form = styled(OrganismForm)`
   margin-top: 50px;
`;
const Button = styled(AtomButton)`
   margin-top: 35px;
   background-color: ${typography.other.color.purple[0]};
`;
const Steps = styled(OrganismSteps)`
   margin-top: 45px;
`;
const Message = styled.div`
   ${typography.other.t3}
   margin-top: 40px;
   line-height: 25px;
   text-align: center;
`;

export default function TemplateStep3(props: PropsType) {
   return (
      <Wrap>
         <AtomTitle>전시회 등록</AtomTitle>
         <Steps step={5}></Steps>
         <Message>
            아트맵 전시회 등록 게재 서비스는 2022년 3월 1일 00시부터 유료로 제공됩니다.
            <br />
            등록하신 자료는 전시등록 지원팀이 확인 후 아트맵 Web/APP 서비스에 게재됩니다.
         </Message>
         <Form data={props.data}></Form>
         <Button onClick={props.succeessOnClick}>결제/완료하기</Button>
      </Wrap>
   );
}
